import moment from "moment";
const inputDateArray = [
    "YYYY",
    "M/YYYY",
    "D/MM/YYYY",
    "MM/YYYY",
    "DD/MM/YYYY",
    "DD-MM-YYYY",
    "YYYY-MM-DD",
    'DD-MMM-YYYY',
    'DD-MMMM-YYYY'
];

export const dateInYYYYMMDD = (date, existingFormat = "") => {
    return moment(date, inputDateArray).format("YYYY-MM-DD");
};

export const dateInDDMMYYYY = (date, sperator = "-") => {
    return moment(date, inputDateArray).format(`DD${sperator}MM${sperator}YYYY`);
};

export const dateInNewDDMMYYYY = (date, separator = "-") => {
    const mDate = moment(date, inputDateArray);
    const formatted = mDate.format(`DD${separator}MM${separator}YYYY`);

    // Create new Date from moment object in standardized format
    return moment(formatted, `DD${separator}MM${separator}YYYY`).toDate();
};

export const NewDateToDDMMYYYY = (date) => {
   return moment(date).format('DD-MM-YYYY');
}